import { connect } from "react-redux";

import { getDatasets, getLoading } from "redux/Datasets/selectors";

import ProgressBarLoaderWrapper from "views/uikit/ProgressBarLoader";
import PublicHeader from "views/components/PublicHeader";
import HealthStatus from "views/components/HealthStatus";
import { State } from "redux/store";
import { useHandleDatasetCreation } from "hooks/useHandleDatasetCreation";

import styles from "./style.module.scss";
import { useUserConfig } from "../../../hooks/useUserConfig";
import VLButton from "views/uikit/Buttons/VLButton";

type HeaderProps = {
  isPrivatePath: boolean;
  datasets: any[];
  isLoading: boolean;
};

const PrivateDisplay = () => {
  const { workspaces } = useUserConfig();
  const { handleDatasetCreation } = useHandleDatasetCreation();

  const datasetCreationEnabled =
    (process.env.REACT_APP_DATASET_CREATION_FROM_UI_ENABLED || "")
      .trim()
      .replace(/"/g, "") === "true" &&
    workspaces?.[0]?.permissions?.can_create_dataset;

  return (
    <div className={styles.headerRight}>
      {datasetCreationEnabled && (
        <VLButton
          text={"+ New Dataset"}
          tooltip="Create a new dataset"
          type="secondary"
          onClick={() => handleDatasetCreation()}
          size="medium"
        />
      )}
      <HealthStatus />
    </div>
  );
};

function Header({ isLoading, isPrivatePath, datasets }: HeaderProps) {
  const renderHeaderTitle = () => {
    return (
      <div className={styles.headerLeft}>
        <span className={styles.headerText}>All Datasets</span>{" "}
        {datasets.length > 0 && (
          <span className={styles.datasetCountTitle}>
            Datasets{" "}
            <span className={styles.datasetCount}>{datasets.length}</span>
          </span>
        )}
      </div>
    );
  };

  return (
    <div className={styles.headerContainer}>
      <div className={styles.upperRow}>
        {renderHeaderTitle()}
        {isPrivatePath ? <PrivateDisplay /> : <PublicHeader isBig={true} />}
      </div>
      <div className={styles.lowerRow}>
        <ProgressBarLoaderWrapper loading={isLoading} />
      </div>
    </div>
  );
}

function mapStatesToProps(state: State) {
  return {
    datasets: getDatasets(state),
    isLoading: getLoading(state),
  };
}

export default connect(mapStatesToProps)(Header);
